export default __webpack_public_path__ + "static/media/Screenshot_1619919073.8cc698b5.png";